import classToggle from '../helpers/class-toggle';

export default () => {
	const sg = document.querySelector('.sg');
	const openButtons = document.querySelectorAll('.js-open-sizeguide');
	const closeButtons = document.querySelectorAll('.js-close-sizeguide');
	
	if (sg) {
		openButtons.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				sg.classList.add('sg--visible');
			});
		});
		closeButtons.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				sg.classList.remove('sg--visible');
			});
		});


		const switches = document.querySelectorAll('.sg__button');
		const tabs = document.querySelectorAll('.sg__tab');
		const ACTIVE_BTN = 'sg__button--active';
		const ACTIVE_TAB = 'sg__tab--active';

		if (switches.length && tabs.length) {
			switches.forEach(function(sw) {
				sw.addEventListener('click', (e) => {
					e.preventDefault();
				
					if (!sw.classList.contains(ACTIVE_BTN)) {
						const index = +sw.dataset.index;
						classToggle(switches, sw, ACTIVE_BTN);
						classToggle(tabs, tabs[index], ACTIVE_TAB);
					}
				});
			});
		}
	}
}